/* tt-upsell (r17upsell): keeps the shipping proposal under the free-shipping bar in step with the cart.
   The proposal is Liquid (snippets/tt-ship.liquid); no sum is repeated here. After a cart change (same signal as tt-cart.js:
   Ride re-renders cart-items and the footer) it re-reads the footer section and swaps ONLY the [data-tt-upsell-ship] node. */
(function () {
  'use strict';
  var timer = null, last = null, busy = false;

  function sig(c) { return c.item_count + ':' + c.total_price; }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (cart) {
        var s = sig(cart);
        if (last === null) { last = s; return; }
        if (s === last) return;
        last = s;
        return fetch(window.location.pathname + '?section_id=main-cart-footer', { headers: { Accept: 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
          .then(function (html) {
            var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tt-upsell-ship]');
            var cur = document.querySelector('[data-tt-upsell-ship]');
            if (cur && next) cur.replaceWith(next);
            else if (cur) cur.remove();
            else if (next) {
              var bar = document.querySelector('[data-tt-ship-bar]');
              if (bar) bar.insertAdjacentElement('afterend', next);
            }
          });
      })
      .catch(function (e) { if (window.console) console.error('tt-upsell', e); })
      .then(function () { busy = false; });
  }

  function later() { clearTimeout(timer); timer = setTimeout(refresh, 450); }

  function start() {
    refresh();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(later);
    ['cart-items', '#main-cart-footer'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) mo.observe(n, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
